import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface CreateActivityAnswerScoreMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
  input: { score: string };
}

export interface CreateActivityAnswerScoreMutationResult {
  answer: ProfessorActivityAnswer;
}

export const createActivityAnswerScoreMutation = gql`
  mutation CreateActivityAnswerScoreMutation(
    $courseId: String!
    $activityId: String!
    $answerId: String!
    $input: CreateActivityAnswerScoreMutationInput!
  ) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId, input: $input)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}/score", method: "POST") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
